export default __webpack_public_path__ + "static/media/envelope-fill.8936841d.svg";